module.exports = __webpack_public_path__ + "fc4b203e9dff11c8c6039c3fc369471d.png";